module.exports = __webpack_public_path__ + "media/images/kanban-b6b28dbb75f64a2c6b7405e626ce0899.png";